import { DatePicker, Select } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { FIELD_WIDTHS } from "../../config/layoutConfig";
import { AppContext } from "../../context";
import "../../style/serviceFilter.css";
import { getCategories } from "./getCategories";
import { MONUMENT } from "./monumentConstants";
import { searchMonuments } from "./searchMonuments";

function MonumentFilter({ setStores, page }) {
  const info = useContext(AppContext);
  const [options, setOptions] = useState([]);

  useEffect(() => {
    (async () => {
      const options = await getCategories(
        "c_stores",
        "monument",
        "mon_category"
      );
      const selectOptions = options?.map((o) => ({
        value: o.mon_category,
        label: info.t(MONUMENT.categories[o.mon_category]).toUpperCase(),
      }));
      setOptions(selectOptions);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      let lodges = await searchMonuments(info, page);
      setStores(lodges);
    })();
  }, [
    info.villages,
    info.name,
    info.monument,
    info.immediateConfirmation,
    page,
  ]);

  return (
    <div className="ahp-service-filter">
      <DatePicker
        placeholder={info.t("date")}
        value={info.monument?.date}
        onChange={(value) =>
          info.setMonument({ ...info.monument, date: value })
        }
        style={{ width: FIELD_WIDTHS.M }}
        bordered={false}
        allowClear={false}
      />

      <div className="ahp-rentabike-category">
        <Select
          placeholder={info.t("category")}
          options={options}
          value={info.monument?.category}
          onChange={(value) => {
            info.setMonument({ ...info.monument, category: value });
          }}
          allowClear
          style={{ width: FIELD_WIDTHS.L }}
          bordered={false}
        />
      </div>
    </div>
  );
}

export default MonumentFilter;
